  function __1generateString(url, format) {
    // Bare bones implementation - to be designed later
    // Parse URL for context (product handle, collection, etc.)
    const urlParts = url.split('/').filter(Boolean);

    // Resolve placeholders in format string
    let result = format;

    // Example: Replace {num} with random number (to be replaced with actual logic)
    result = result.replace(/\{num\}/g, Math.floor(Math.random() * 10));

    // Example: Replace {hour} with random hour value (to be replaced with actual logic)
    result = result.replace(/\{hour\}/g, Math.ceil(Math.random() * 24));

    console.log(result);
    return result;
  }

  var el = document.querySelector('[data-sale-string-display]')
  const format = el?.dataset.format || '{num} sold in {hour} hours';
  const url = window.location.href;
  el.innerText = __1generateString(url, format);